export const ROUTES = {
    LANDING: '/',
    // FORGOTTEN_PASSWORD: {
    //     SEND: '/reset-password',
    //     VERIFY: '/reset-password/verify/:code',
    //     RESET: '/reset-password/reset',
    // },
    HOME: '/home',
    PROFILE: '/profile',
    CHECKOUT_VALIDATION: '/checkout/validation',
    EXPERIENCE: {
        EXPERIENCELIST: '/experience',
        EXPERIENCEWIZARD: '/experience/add',
        EXPERIENCEID: '/experience/:id',
        EXPERIENCEPROFILE: '/experience/:id/profile',
        EXPERIENCERESOURCE: '/experience/:id/resource',
        EXPERIENCETERMS: '/experience/:id/terms',
        EXPERIENCEOPTIONS: '/experience/:id/options',
        EXPERIENCESCHEDULING: '/experience/:id/scheduling',
        EXPERIENCEEDIT: '/experience/:id/edit',
        EXPERIENCEUNITS: '/experience/:id/units',
    },
    REPORTS: '/report',
    BOOKINGS: {
        GLOBAL: '/booking',
        ADD: '/booking/add',
        NEW: '/booking/new',
        ID: '/booking/:id',
        DATE: '/booking/:date/:expId/:subExpId',
    },
    RESOURCE: {
        RESOURCE: '/resource',
        ADD: '/resource/add',
    },
    UNITS: '/units',
    PRICING: {
        PRICELIST: '/price-list',
        PRICELISTID: '/price-list/:id',
        PRICEGROUPWIZARD: '/price-list/:id/price-group/add',
        PRICEGROUPID: '/price-group/:id',
    },
};
